import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';


export const getOcppChargers = createAsyncThunk('get/getOcppChargers', async (params) => {
  const response = await axios.get('/charger/', { params });
  return response.data;
});

export const addOcppCharger = createAsyncThunk('add/addOcppCharger', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/create_ocpp/', data);
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getOcppChargerById = createAsyncThunk('charger/getOcppChargerById', async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/charger/${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addConnector = createAsyncThunk('add/addConnector', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/add_connector/', data);
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const listConfigKeys = createAsyncThunk('list/listConfigKeys', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/ocpp/list_config_keys/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const listAvailabilityTypes = createAsyncThunk('list/listAvailabilityTypes', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/ocpp/list_availability_types/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const listMessagesTrigger = createAsyncThunk('list/listMessagesTrigger', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/ocpp/list_trigger_messages/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const listResetTypes = createAsyncThunk('list/listResetTypes', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/ocpp/list_reset_types/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteCharger = createAsyncThunk('deleteCharger', async (chargerId, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/charger/${chargerId}/`);
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyChargers = createAsyncThunk(
  'deleteManyChargers',
  async (chargerIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/charger/delete_many/', { data: { arrId: chargerIDs } });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeConnector = createAsyncThunk('remove/removeConnector', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/remove_connector/', id);
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// remote commands
export const remoteStartTransaction = createAsyncThunk(
  'remote/remoteStartTransaction',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/start_transaction/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteStopTransaction = createAsyncThunk(
  'remote/remoteStopTransaction',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/stop_transaction/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteGetConfiguration = createAsyncThunk(
  'remote/remoteGetConfiguration',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/get_configuration/', { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteReset = createAsyncThunk('remote/remoteReset', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.get('/remote-message/reset/', { params });
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const remoteChangeAvailability = createAsyncThunk(
  'remote/remoteChangeAvailability',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/change_availability/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteTriggerMessage = createAsyncThunk(
  'remote/remoteTriggerMessage',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/trigger_message/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteUnlockConnector = createAsyncThunk(
  'remote/remoteUnlockConnector',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/unlock_connector/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteDataTransfer = createAsyncThunk(
  'remote/dataTransfer',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/remote-message/data_transfer/', data);
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const remoteListVersion = createAsyncThunk(
  'remote/remoteListVersion',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/list_version/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remoteClearCache = createAsyncThunk(
  'remote/remoteClearCache',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/clear_cache/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const remotechangeConfiguration = createAsyncThunk(
  'remote/remotechangeConfiguration',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/remote-message/change_configuration/', { params });
      dispatch(getOcppChargers({ type: 'OCPP' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getFirmwares = createAsyncThunk('get/getFirmwares', async () => {
  const response = await axios.get('/list_firmware');
  return response.data;
});

export const updateFirmware = createAsyncThunk('post/updateFirmware', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post(`/remote-message/update_firmware/`, data);
    dispatch(getOcppChargers({ type: 'OCPP' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateCharger = createAsyncThunk('update/charger', async ({ id, data }, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put(`/charger/${id}/`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addProviderToChargers = createAsyncThunk(
  'addProviderToChargers/charger',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/charger/add_provider/', data);
      return response.data;
    } catch {
      return rejectWithValue(error);
    }
  }
);

export const addProfile = createAsyncThunk('post/addProfile', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/add_profile/', params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const removeProfile = createAsyncThunk('delete/removeProfile', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/charger/remove_profile/`, { params: { id: id } });
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getProfile = createAsyncThunk('get/getProfile', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.get(`/charger/get_profile/`, { params: { charger_id: id } });
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const ocppChargerAdapter = createEntityAdapter({});

const ocppChargerSlice = createSlice({
  name: 'ocppChargers',
  initialState: ocppChargerAdapter.getInitialState({
    ocppChargers: [],
    availabilityTypes: [],
    messages: [],
    resetTypes: [],
    keys: [],
    currentOcpp: null,
    ocppById: null,
    config: null,
    connectors: [],
    configurations: [],
    searchText: '',
    routeParams: {},
    loading: false,
    isSubmitting: false,
    openDialog: false,
    openProfileTable: false,
    currentChargingProfile: null,
    firmwares: [],
    refresh: false
  }),
  reducers: {
    setOpenProfileDialog(state, action) {
      state.openProfileTable = action.payload;
    },

    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setCurrentOcpp: (state, action) => {
      state.currentOcpp = action.payload;
    },
    setOpenDialog(state, action) {
      state.openDialog = action.payload;
    },
    resetConfig(state, action) {
      state.config = action.payload;
    },
    setRefresh(state, action) {
      state.refresh = action.payload
    }
  },
  extraReducers: {
    // ---------------------------------------------------
    [getOcppChargerById.pending]: (state) => {
      state.loading = true;
    },
    [getOcppChargerById.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.ocppById = data;
      state.loading = false;
    },
    [getOcppChargerById.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------------------
    [listConfigKeys.pending]: (state) => {
      state.loading = true;
    },

    [listConfigKeys.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.keys = data;
      state.loading = false;
    },
    [listConfigKeys.rejected]: (state) => {
      state.loading = false;
    },
    // --------------------------------------
    [listAvailabilityTypes.pending]: (state) => {
      state.loading = true;
    },
    [listAvailabilityTypes.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.availabilityTypes = data;
      state.loading = false;
    },
    [listAvailabilityTypes.rejected]: (state) => {
      state.loading = false;
    },
    // --------------------------------------
    [listMessagesTrigger.pending]: (state) => {
      state.loading = true;
    },
    [listMessagesTrigger.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.messages = data;
      state.loading = false;
    },
    [listMessagesTrigger.rejected]: (state) => {
      state.loading = false;
    },
    // --------------------------------------
    [listResetTypes.pending]: (state) => {
      state.loading = true;
    },
    [listResetTypes.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.resetTypes = data;
      state.loading = false;
    },
    [listResetTypes.rejected]: (state) => {
      state.loading = false;
    },

    // --------------------------------------
    [getOcppChargers.pending]: (state) => {
      state.loading = true;
    },
    [getOcppChargers.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.ocppChargers = data;
      state.loading = false;
      state.refresh = false;
    },
    [getOcppChargers.rejected]: (state) => {
      state.loading = false;
    },
    // --------------------------------------
    [addOcppCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addOcppCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addOcppCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [addConnector.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addConnector.fulfilled]: (state, action) => {
      state.connectors = action.payload;
      state.isSubmitting = false;
    },
    [addConnector.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ------------------------------------
    [removeConnector.pending]: (state) => {
      state.isSubmitting = true;
    },
    [removeConnector.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [removeConnector.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // --------------------------------------
    [remoteStartTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStartTransaction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
    },
    [remoteStartTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteStopTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStopTransaction.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteStopTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteGetConfiguration.pending]: (state) => {
      state.loading = false;
    },
    [remoteGetConfiguration.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.configurations = data;
      state.loading = false;
    },
    [remoteGetConfiguration.rejected]: (state) => {
      state.loading = false;
    },
    // --------------------------------------
    [remoteStopTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStopTransaction.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteStopTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteReset.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteReset.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteReset.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteChangeAvailability.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteChangeAvailability.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteChangeAvailability.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteTriggerMessage.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteTriggerMessage.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteTriggerMessage.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteUnlockConnector.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteUnlockConnector.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteUnlockConnector.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteListVersion.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteListVersion.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteListVersion.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteClearCache.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteClearCache.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteClearCache.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remotechangeConfiguration.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remotechangeConfiguration.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remotechangeConfiguration.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -----------------------------------------
    [deleteManyChargers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyChargers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyChargers.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -----------------------------------

    // --------------------------------------
    [remoteStartTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStartTransaction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
    },
    [remoteStartTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteStopTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStopTransaction.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteStopTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteGetConfiguration.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteGetConfiguration.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.configurations = data;
      state.isSubmitting = false;
      state.loading = false;
    },
    [remoteGetConfiguration.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteStopTransaction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteStopTransaction.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteStopTransaction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteReset.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteReset.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteReset.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteChangeAvailability.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteChangeAvailability.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteChangeAvailability.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteTriggerMessage.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteTriggerMessage.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteTriggerMessage.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteUnlockConnector.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteUnlockConnector.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteUnlockConnector.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteListVersion.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteListVersion.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteListVersion.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remoteClearCache.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remoteClearCache.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remoteClearCache.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // --------------------------------------
    [remotechangeConfiguration.pending]: (state) => {
      state.isSubmitting = true;
    },
    [remotechangeConfiguration.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [remotechangeConfiguration.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -----------------------------------------
    [deleteManyChargers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyChargers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyChargers.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -----------------------------------

    [deleteCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------
    [updateCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [addProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [removeProfile.pending]: (state) => {
      state.isSubmitting = true;
    },
    [removeProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [removeProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [getProfile.pending]: (state) => {
      state.loading = true;
    },
    [getProfile.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.currentChargingProfile = data;
      state.loading = false;
    },
    [getProfile.rejected]: (state) => {
      state.loading = false;
    },

    // ---------------------------------------------
    [updateFirmware.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateFirmware.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateFirmware.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------------
    [getFirmwares.pending]: (state) => {
      state.loading = true;
    },
    [getFirmwares.fulfilled]: (state, action) => {
      state.firmwares = action.payload.data;
      state.loading = false;
    },
    [getFirmwares.rejected]: (state) => {
      state.loading = false;
    },

    // ---------------------------------------------
    [remoteDataTransfer.pending]: (state) => {
      state.loading = true;
    },
    [remoteDataTransfer.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [remoteDataTransfer.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { setRefresh, setSearchText, setCurrentOcpp, setOpenDialog, resetConfig, setOpenProfileDialog } =
  ocppChargerSlice.actions;

export default ocppChargerSlice.reducer;
